"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SalesOrderLineSearchResponse = void 0;
const common_1 = require("../../common");
const models_1 = require("../models");
class SalesOrderLineSearchResponse extends common_1.PaginatedResponse {
}
exports.SalesOrderLineSearchResponse = SalesOrderLineSearchResponse;
//# sourceMappingURL=sales-order-line-search.response.js.map